// @flow

import fieldsModuleMapping from '../config/fieldsModuleMapping';

const getNotesFieldMapping = (moduleName: string) => {
  const mapping = fieldsModuleMapping[moduleName];

  if (!mapping) {
    return '';
  }

  const { notes: fieldName } = mapping;

  return fieldName;
};

export { getNotesFieldMapping };
